<canvas #histogram></canvas>
<mat-progress-bar *ngIf="loading()" mode="indeterminate"></mat-progress-bar>
